// extracted by mini-css-extract-plugin
export default {"surveyContainer":"styles_surveyContainer__gPeIQ"};